/**
 * @description The utility function structuredClone() creates a deep clone of a given value using the structured clone algorithm.
 * @description The method also allows transferable objects in the original value to be transferred rather than cloned to the new object.
 * Transferred objects are detached from the original object and attached to the new object; they are no longer accessible in the original object.
 * @type Object | Array
 * @param {(Object | Array)} any - The value to clone.
 * @returns new value that is a deep clone of the original value.
 */
export const structuredClone = any => JSON.parse(JSON.stringify(any))
